<template>
  <vx-card no-shadow>
    <form-wizard data-vv-scope="info_usuario" id="formUsuarios" ref="wizard" :color="null" :nextButtonText="null" :backButtonText="null" :finishButtonText="null" :errorColor="null" :title="null" :subtitle="null">
      <div class="vx-row">
        <div class="flex flex-wrap items-center mb-base vx-col">
          <img key="onlineImg"  v-if="activeUserInfo.photoURL" :src="activeUserInfo.photoURL" alt="user-img" width="130" height="130" class="rounded-full shadow-md cursor-pointer block" />
          <img key="onlineImg"  v-else src="../../assets/images/user.png" alt="user-img" width="130" height="130" class="rounded-full shadow-md cursor-pointer block" />&nbsp;&nbsp;
          <div class="custom-input-file col-md-4 col-sm-4 col-xs-4">
            <input accept=".jpg,.png,.jpeg,.gif" type="file" id="file" class="input-file" value="" @change="onFileChanged()"/>
            Subir Imagen...
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div class="col-md-4 col-sm-4 col-xs-4">
            <vs-button color="danger" type="filled" icon="delete" @click="delFoto()">Eliminar Imagen...</vs-button>
          </div>
        </div>
      </div>
      <div class="vx-row ">
        <div class="vx-col md:w-2/5 w-full">
          <vs-input label="Empresa"  v-model="empresa" class="w-full mt-4" name="empresa" v-validate="'required'" />
          <span class="text-danger">{{ errors.first('info_usuario.empresa') }}</span>
        </div>
        <div class="vx-col md:w-2/5 w-full">
          <vs-input label="Email"  v-model="email" class="w-full mt-4" name="email" v-validate="'required|email'" readonly/>
          <span class="text-danger">{{ errors.first('info_usuario.email') }}</span>
        </div>
        <div class="vx-col md:w-2/5 w-full mt-4">
          <label class="vs-input--label">Pais</label>
          <v-select v-model="pais" class="w-full select-large" name="pais" v-validate="'required'" label="nombre" :options="Paises" placeholder="Elige una opción"></v-select>
          <span class="text-danger">{{ errors.first('info_usuario.pais') }}</span>
        </div>
        <!-- <div class="vx-col md:w-1/5 w-full">
          <vs-input label="Estado"  v-model="estado" class="w-full mt-4" name="estado" v-validate="'required'" />
          <span class="text-danger">{{ errors.first('info_usuario.estado') }}</span>
        </div>
        <div class="vx-col md:w-2/5 w-full">
          <vs-input label="Municipio"  v-model="municipio" class="w-full mt-4" name="municipio" v-validate="'required'" />
          <span class="text-danger">{{ errors.first('info_usuario.municipio') }}</span>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <vs-input label="Codigo Postal"  v-model="cp" class="w-full mt-4" name="cp" v-validate="'required|regex:^[0-9]{5}$'" />
          <span class="text-danger">{{ errors.first('info_usuario.cp') }}</span>
        </div>
        <div class="vx-col md:w-2/5 w-full">
          <vs-input label="Colonia"  v-model="colonia" class="w-full mt-4" name="colonia" v-validate="'required'" />
          <span class="text-danger">{{ errors.first('info_usuario.colonia') }}</span>
        </div>
        <div class="vx-col md:w-3/5 w-full">
          <vs-input label="Calle y Número"  v-model="calle" class="w-full mt-4" name="calle" v-validate="'required'" />
          <span class="text-danger">{{ errors.first('info_usuario.calle') }}</span>
        </div> -->
      </div>
      <div class="vx-row ">
        <div class="vx-col md:w-1/5 w-full">
          <vs-input label="RFC" v-model="rfc" class="w-full mt-4" name="rfc" v-validate="'required'" disabled/>
          <span class="text-danger">{{ errors.first('info_usuario.rfc') }}</span>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <div class="custom-input-filerfc">
            <input accept=".pdf" type="file" id="filerfc" class="input-file" value="" @change="onFileChangedrfc()"/>
            Subir RFC...
          </div>
        </div>
        <div class="vx-col md:w-1/5 w-full" v-if="this.rfcdoc != null && this.rfcdoc != ''" >
            <div v-if="this.verpdf == 2 ">
              <vs-button color="warning" style='margin-top:33px' type="filled" size="middle" @click="EsconderPDF();"> Esconder PDF RFC</vs-button>
            </div>
            <div v-else>
              <vs-button color="success" style='margin-top:33px'  type="filled" size="middle" @click="VerPDF();"> Ver mi RFC</vs-button>
            </div>
        </div>
      </div>
  
      <div class="vx-row" v-if="this.verpdf == 2 ">
        <div class="vx-col xl:w-3/12 mt-5">
          <embed style="width:700px;height:900px" type="application/pdf" :src="'data:application/pdf;base64,'+this.rfcdoc"/>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col xl:w-12/12 mt-5" >
        <vs-collapse>
          <vs-collapse-item style="text-align: justify !important">
            <div slot="header">
              Aviso de Privacidad de la Plataforma de Lealtad VIVOTEK
            </div>
            En vigor a partir del 1 de enero de 2021.<br>
            En el presente Aviso de Privacidad se especifica la información que la Plataforma
            de Lealtad VIVOTEK recaba y utiliza acerca de los usuarios o consumidores que
            en esta se registran, así como se detallan las medidas que tomamos para
            protegerla.<br><br>
            INFORMACIÓN RECABADA<br><br>
            La información que recabamos en la Plataforma de Lealtad VIVOTEK sobre nuestros usuarios o consumidores, a fin de realizar con éxito los servicios que en<br>
            ella ofrecemos, son los siguientes:<br>
            * Nombre completo<br>
            * Domicilio<br>
            * Dirección de correo electrónico<br>
            * Fotografía<br>
            * Nombre de usuario<br>
            * Contraseña de acceso<br>
            * Registro Federal de Contribuyentes (RFC)<br><br>
            USO DE LA INFORMACIÓN RECABADA<br><br>
            La información recabada por la Plataforma de Lealtad VIVOTEK sobre nuestros
            usuarios o consumidores puede o no ser utilizada para lo siguiente:<br>
            * Entregar y monitorear los envíos de productos.<br>
            * Brindar atención a nuestros usuarios o consumidores.<br>
            * Enviar a nuestros usuarios o consumidores comunicaciones electrónicas<br>
            (ofertas, noticias, lanzamientos).<br>
            * Elaborar análisis de datos.<br>
            * Identificar y ampararnos ante posibles actividades delictivas y<br>
            reclamaciones infundadas, entre otras actividades ilegítimas.<br><br>
            INFORMACIÓN COMPARTIDA<br><br>
            La información recabada por la Plataforma de Lealtad VIVOTEK sobre nuestros
            usuarios o consumidores será compartida únicamente si así nos lo exige la ley<br>
            (incluyendo reglamentos y procesos legales) por demanda de alguna entidad
            gubernamental, o si consideramos que dicha información pude ser útil para la
            prevención de daños físicos o económicos.<br>
            Nos reservamos el derecho de transferir cualquier información que tengamos
            sobre nuestros usuarios o consumidores en caso de vender o transferir, de
            manera total o parcial, nuestros negocios o activos.<br><br>
            ACTUALIZACIONES DE NUESTRO AVISO DE PRIVACIDAD<br><br>
            El presente Aviso de Privacidad puede ser sujeto a modificaciones sin que
            estemos obligados a notificar a nuestros usuarios o consumidores.
            La fecha en que se haya realizado la actualización más reciente será indicada en
            la parte superior de las declaraciones de este Aviso de Privacidad.<br><br>
            CONTACTO<br><br>
            Si desea acceder a su información, o solicitar alguna actualización, modificación,
            rectificación o eliminación de su información, no dude en contactarnos a través de
            soporte.rewards@vivotek.com.<br>
          </vs-collapse-item>
        </vs-collapse>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col xl:w-3/12 mt-5">
          <vs-button color="success" type="filled" size="middle" icon="save" @click="validar();"> Guardar</vs-button>
        </div>
      </div>
    </form-wizard>
  </vx-card>
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import flatPickr from 'vue-flatpickr-component'
import 'sweetalert2/dist/sweetalert2.min.css';
import Datepicker from 'vuejs-datepicker'
import axios from '../../axios.js'
import vSelect from 'vue-select'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    email: {
      required: 'El e-mail es requerido',
      email: 'Ingresa un e-mail valido'
    },
  }
}
Validator.localize('es', dict)
export default {
  components: {
    flatPickr,
    vSelect
  },
  data () {
    return {
      ruta: "",
      Paises: [],
      pais: [],
      rfc: '',
      empresa: '',
      email: '',
     /*  estado: '',
      municipio: '',
      colonia: '',
      cp: '',
      calle: '', */
      verpdf: '',
      rfcdoc: '',
    }
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent
  }, 
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    init(){
      this.openLoading();
      this.verPaises();
      this.consultar();
    },
    openLoading(){
      this.$vs.loading({type:'corners'});
    },
    closeLoading(){
      this.$vs.loading.close();
    },
    onFileChanged () {
      const file = event.target.files[0];
      let formData = new FormData();
      formData.append('file', file);
      this.openLoading();
      this.$http.postform('Empresas','GuardarFoto',formData,(data)=>{
        if(data){
          this.$store.state.AppActiveUser.photoURL =  data;
          this.$vs.notify({title:'Alerta',text:'Foto perfil actualizada correctamente.',color:'success',icon:'check_box',time:8000});
        } else {
          this.$vs.notify({title:'Error',text:'Su foto no tiene una extensión válida o excede de los 500kb.',color:'danger',icon:'check_box',time:8000});
        }
        this.closeLoading();
      });
    },
    VerPDF(){
      this.verpdf = 2;
    },
    EsconderPDF(){
      this.verpdf = 1;
    },
    onFileChangedrfc () {
      const filerfc = event.target.files[0];
      let formData = new FormData();
      formData.append('filerfc', filerfc);
      this.openLoading();
      this.$http.postform('Empresas','GuardarRFC',formData,(data)=>{
        if(data){
          this.VerPDF();
          this.consultar();
          this.$vs.notify({title:'Alerta',text:'RFC guardado correctamente.',color:'success',icon:'check_box',time:8000});
        }
        this.closeLoading();
      });
    },
    delFoto(){
      this.$swal({
          title: "¿Estás seguro de eliminar la foto de perfil?",
          text: "No podrás recuperar esta foto!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Si",
        }).then(async (result) => {
          if (result.value) {
            this.openLoading();
            this.$http.post('Empresas','EliminarFoto',{},(data)=>{
              if(data == ''){
                this.$store.state.AppActiveUser.photoURL =  '';
                this.$vs.notify({title:'Alerta',text:'Foto perfil eliminada correctamente.',color:'success',icon:'check_box',time:8000});
              } else {
                this.$vs.notify({title:'Error',text:'Su foto no fue eliminada.',color:'danger',icon:'check_box',time:8000});
              }
              this.closeLoading();
            });
          }
        });
    },
    consultar(){
      this.$http.post('Empresas','consultarInfoPerfil',{},(data)=>{
        if(data){
          this.rfc = data.rfc;
          this.empresa = data.empresa;
          this.email = data.email;
          this.pais = {id: data.pais , nombre: data.paisnombre};
          /* this.estado = data.estado;
          this.municipio = data.municipio;
          this.cp = data.cp;
          this.colonia = data.colonia;
          this.calle = data.calle; */
          this.ruta = data.ruta;
          this.rfcdoc = data.rfcdoc;
          if(this.rfcdoc == null || this.rfcdoc == ''){
            this.verpdf = 1;
          }else{
            this.verpdf = 2;
          }
        }else{
          this.$vs.notify({title:'Error',text:'Error al consultar la información',color:'danger',icon:'alert',time:5000})               
        }
        this.closeLoading();
      });
    },
    validar(){
      this.$validator.validateAll('info_usuario').then(result => {
        if(result){
          this.guardar();
        }
      })
    },
    guardar(){
      const POST = {
        rfc: this.rfc,
        empresa: this.empresa,
        email: this.email,
        pais: (this.pais.id != undefined)? this.pais.id : 0,
       /*  estado: this.estado,
        municipio: this.municipio,
        cp: this.cp,
        colonia: this.colonia,
        calle: this.calle */
      };
      this.openLoading();
      this.$http.post('Empresas','GuardarInfoUsuario',{POST},(data)=>{
        if(data){
          this.$store.state.AppActiveUser.displayPunt = data.puntos;
          if(this.empresa!='' ){
            this.$store.state.AppActiveUser.displayName =  this.empresa;
          }else{
            this.$store.state.AppActiveUser.displayName =  this.email;
          }
          this.$vs.notify({title:'Perfil',text:'información actualizada correctamente.',color:'success',icon:'check',time:5000})
        } else{
          this.$vs.notify({title:'Perfil',text:'no se realizarión cambios en su información',color:'warning',icon:'alert',time:5000})               
        }
        this.closeLoading();
      });
    },
    verPaises(){
      this.$http.post('Comun','getPaises',{},(data)=>{
        this.Paises = data;
      });
    },
  },
  mounted() {
    this.init();
  },
}
</script>
}
<style lang="scss">
  .custom-input-file {
    background-color: #3498db;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    margin: 0 auto 0;
    min-height: 7px;
    overflow: hidden;
    padding: 12px;
    position: relative;
    text-align: center;
    width: 200px;
    border-radius: 10px;
    box-shadow: 200px ;
  }
  .custom-input-file .input-file {
    border: 10000px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    font-size: 10000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
    right: -1000px;
    top: -1000px;
  }

  .custom-input-filerfc {
    margin-top:33px;
    background-color: #3498db;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    min-height: 7px;
    overflow: hidden;
    padding: 10px;
    position: relative;
    text-align: center;
    width: 200px;
    border-radius: 10px;
  }
  .custom-input-filerfc .input-file {
    border: 1000px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    font-size: 1000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
  }
</style>